module.exports = __webpack_public_path__ + "img/technology-7.cf5cb905.png";